"use client";
import { signOut } from "next-auth/react";
import { LogOut } from "lucide-react";
import { InteractiveButton } from "../button/InteractiveButton";

export const SignOutButton = () => {
  return (
    <InteractiveButton
      variant={"ghost"}
      onClick={() => signOut()}
      icon={<LogOut className="h-4" />}
      data-umami-event="account-nav-upgrade-button-clicked"
      label="Sign out"
      className="pl-1"
      revert={true}
    ></InteractiveButton>
  );
};
